// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__uDgRI","savePackageButton":"ClientWallet_savePackageButton__2HAcL"};